<script setup>
import { computed } from "vue";

const props = defineProps({
    color: {
        default: "gray",
        type: String,
    },
});

const classes = computed(() => {
    const colors = {
        white: "text-gray-800 bg-gray-100",
        gray: "bg-gray-300 text-gray-800",
        dark: "bg-gray-300 text-gray-800",
        teal: "text-blue-800 bg-blue-100",
        red: "bg-red-100 text-red-800",
        yellow: "bg-yellow-100 text-yellow-800",
        green: "bg-green-100 text-green-800",
        blue: "text-blue-800 bg-blue-100",
        indigo: "text-indigo-800 bg-indigo-100",
        purple: "text-purple-800 bg-purple-100",
        pink: "text-pink-800 bg-pink-100",
    };

    return colors[props.color];
});
</script>

<template>
    <span
        :class="[
            'me-2 inline-flex items-center rounded-full px-2.5 py-0.5 text-center text-sm font-medium',
            classes,
        ]"
    >
        <slot />
    </span>
</template>
